module.exports = __webpack_public_path__ + "static/img/spectrum-logo-lg.af0c55f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spectrum-logo-lg.jpg
// module id = IPGF
// module chunks = 0